import { signOut } from "firebase/auth";
import toast from "react-hot-toast";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { auth } from "../../network/firebaseConfig";
import { LogOut, Users, ClipboardList, CheckCircle, Home } from "lucide-react";

const Sidebar = ({ user, collapsed }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleLogout = async () => {
        try {
            await signOut(auth);
            navigate("/auth");
            toast.success("Logged out successfully!");
        } catch (error) {
            console.error("Logout failed:", error);
            toast.error("Error signing out. Please try again.");
        }
    };

    const menuItems = [
        {
            path: "/complaints",
            label: "Complaints",
            icon: <ClipboardList size={18} />,
            roles: ["admin", "technician", "helpdesk"],
        },
        {
            path: "/complaints/completed",
            label: "Completed Complaints",
            icon: <CheckCircle size={18} />,
            roles: ["admin"],
        },
        {
            path: "/users",
            label: "Users Management",
            icon: <Users size={18} />,
            roles: ["admin"],
        },
    ];

    return (
        <aside
            className={`
        bg-white border-r shadow-md flex flex-col h-full transition-all duration-300
        ${collapsed ? "w-16 items-center" : "w-64"}
      `}
        >
            {/* Header */}
            <div
                onClick={() => navigate("/")}
                className={`flex items-center justify-center cursor-pointer py-6 border-b border-gray-100`}
            >
                <h1
                    className={`text-teal-500 font-bold transition-all duration-200 ${collapsed ? "text-sm" : "text-xl"
                        }`}
                >
                    ISP CT
                </h1>
            </div>

            {/* Navigation */}
            <nav className="flex flex-col gap-1 mt-4 flex-1 px-2">
                {menuItems.map(
                    (item) =>
                        user &&
                        item.roles.includes(user.role) && (
                            <Link
                                key={item.path}
                                to={item.path}
                                className={`flex items-center gap-3 p-2 rounded-md transition-all duration-200 
                  ${location.pathname === item.path
                                        ? "bg-teal-100 text-teal-600"
                                        : "text-gray-700 hover:bg-gray-100"
                                    }
                  ${collapsed ? "justify-center" : ""}
                `}
                            >
                                {item.icon}
                                {!collapsed && <span>{item.label}</span>}
                            </Link>
                        )
                )}
            </nav>

            {/* Footer */}
            <div
                className={`border-t border-gray-200 px-3 py-4 text-gray-700 text-sm transition-all duration-200 ${collapsed ? "text-center" : ""
                    }`}
            >
                {!collapsed && (
                    <>
                        <p>
                            Logged in as:{" "}
                            <strong>{user && (user.name || user.email)}</strong>
                        </p>
                        <p className="capitalize">{(user && user.role) || ""}</p>
                    </>
                )}

                {/* Logout */}
                <button
                    onClick={handleLogout}
                    className={`mt-3 flex items-center justify-center gap-2 w-full bg-pink-500 hover:bg-pink-600 text-white text-sm py-2 rounded-md`}
                >
                    <LogOut size={16} />
                    {!collapsed && "Logout"}
                </button>
            </div>
        </aside>
    );
};

export default Sidebar;


// import toast from "react-hot-toast";
// import { Link, useNavigate } from "react-router-dom";
// import { auth } from "../../network/firebaseConfig";

// const Sidebar = ({ user }) => {
//     const navigate = useNavigate();

//     const handleLogout = async () => {
//         try {
//             await signOut(auth);
//             navigate("/auth");
//         } catch (error) {
//             console.error("Logout failed:", error);
//             toast("Error signing out. Please try again.");
//         }
//     };

//     return (
//         <aside className="box-shadow w-64 bg-gray-100 text-gray-600 shadow-lg max-h-screen min-h-screen flex flex-col p-4">
//             {/* Header / Brand */}
//             <div className="h-[100px] flex items-center justify-center bg-gray-100">
//                 <h1 className="text-xl text-teal-400 font-bold">ISP CT</h1>
//             </div>

//             {/* Navigation */}
//             <nav className="flex flex-col gap-2 mt-4">
//                 {user && user.role === "helpdesk" && (
//                     <Link to="/complain-form" className="hover:bg-gray-100 text-gray-800 p-2 rounded">
//                         Record Complaint
//                     </Link>
//                 )}
//                 {(user && user.role === "admin" || user && user.role === "technician" || user && user.role === "helpdesk") && (
//                     <Link to="/complaints" className="hover:bg-gray-100 p-2 text-gray-800 rounded">
//                         Complaints
//                     </Link>
//                 )}

//                 {user && user.role === "admin" && (
//                     <Link
//                         to="/complaints/completed"
//                         className="hover:bg-gray-100 text-gray-800 p-2 rounded"
//                     >
//                         Completed Complaints
//                     </Link>
//                 )}

//                 {user && user.role === "admin" && (
//                     <Link to="/users" className="hover:bg-gray-100 text-gray-800 p-2 rounded">
//                         Users Management
//                     </Link>
//                 )}
//             </nav>

//             {/* Footer Section */}
//             <div className="mt-auto text-gray-800 text-sm px-2 py-4 border-t border-gray-700">
//                 <p>
//                     Logged in as: <strong>{user && (user.name || user.email)}</strong>
//                 </p>
//                 <p className="capitalize">{user && user.role || ""}</p>

//                 {/* Logout Button */}
//                 <button
//                     onClick={handleLogout}
//                     className="mt-3 w-full bg-red-500 hover:bg-red-600 text-white text-sm py-2 rounded-md"
//                 >
//                     Logout
//                 </button>
//             </div>
//         </aside>
//     );
// };

// export default Sidebar;
